import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/msalConfig';
import { initializeAuth } from './services/auth';
import { initTelemetry } from './services/telemetry';
import App from './App';
import './index.css';

initTelemetry();

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  initializeAuth(msalInstance);
  msalInstance.handleRedirectPromise().then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </StrictMode>
    );
  });
});
